/* tslint:disable */
/* eslint-disable */
/**
 * Limber Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    VideoAnalyticsData,
    VideoAnalyticsDataFromJSON,
    VideoAnalyticsDataFromJSONTyped,
    VideoAnalyticsDataToJSON,
} from './';

/**
 * 
 * @export
 * @interface VideosAnalyticsData
 */
export interface VideosAnalyticsData {
    [key: string]: VideoAnalyticsData | any;
    /**
     * 
     * @type {VideoAnalyticsData}
     * @memberof VideosAnalyticsData
     */
    all: VideoAnalyticsData;
}

export function VideosAnalyticsDataFromJSON(json: any): VideosAnalyticsData {
    return VideosAnalyticsDataFromJSONTyped(json, false);
}

export function VideosAnalyticsDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): VideosAnalyticsData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
            ...json,
        'all': VideoAnalyticsDataFromJSON(json['all']),
    };
}

export function VideosAnalyticsDataToJSON(value?: VideosAnalyticsData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
            ...value,
        'all': VideoAnalyticsDataToJSON(value.all),
    };
}


